// @flow

import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Section from './Section';

import IosSwitch from '../../../../../elements/IosSwitch/IosSwitch';
import {Chip, FormControlLabel, makeStyles} from '@material-ui/core';
import {colors} from '../../../../../assets/styles/colors';
import {useIsFeatureInTier} from '../../../../../utils/component';

import type {StoreProductSetting} from '../../../../ui/duck';

type Props = {
  productSetting?: StoreProductSetting,
  saveProductSetting: any => void,
  disabled?: boolean,
};

const useStyles = makeStyles(() => ({
  label: {
    fontWeight: 'normal',
    fontSize: '14px',
    color: colors.grey700,
  },
  newLabel: {
    background: '#F5F0FF',
    marginLeft: 10,
    fontWeight: 600,
    '& span': {
      fontSize: '11px!important',
      color: '#7B39FF',
    },
  },
}));

export default function LiveViewsSection(props: Props) {
  const {productSetting, saveProductSetting, disabled} = props;
  const classes = useStyles();

  const hasProductLiveViewsFeature = useIsFeatureInTier('PRODUCT_LIVE_VIEWS');
  const [enabled, setEnabled] = useState<boolean>(
    !!productSetting && !!productSetting.enabledLiveViews
  );

  useEffect(() => {
    setEnabled(!!productSetting && !!productSetting.enabledLiveViews);
  }, [productSetting]);

  const handleEnableChange = e => {
    saveProductSetting({
      productSettingRequest: {
        enabledLiveViews: e.target.checked,
      },
    });
  };

  const buildSwitchControl = () => {
    return (
      <>
        {!hasProductLiveViewsFeature && (
          <Chip label="PRO+" size="small" className={classes.newLabel} />
        )}
        <FormControlLabel
          control={
            <IosSwitch
              name="enabledLiveViews"
              onChange={handleEnableChange}
              checked={enabled}
              disabled={!!disabled || !hasProductLiveViewsFeature}
            />
          }
          labelPlacement="start"
          label={
            <div className={classes.label}>
              {enabled ? 'Activado' : 'Desactivado'}
            </div>
          }
        />
      </>
    );
  };

  return (
    <div>
      <Section
        title="Mostrar cantidad de personas mirando tu producto"
        action={buildSwitchControl()}
      />
    </div>
  );
}

LiveViewsSection.propTypes = {
  productSetting: PropTypes.object,
  saveProductSetting: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
